"use client";

import { useTranslations } from "next-intl";

export default function TermsAndServicesAgreement() {
  const t = useTranslations("auth.passwordForget.tos");
  return (
    <div className="mt-3 w-full max-w-md pb-2 text-center text-xs text-gray-500 sm:mt-6 sm:pb-4 dark:text-gray-400">
      {t("byContinuing")}{" "}
      <a
        href="https://www.optogrid.com/terms-of-service/"
        target="_blank"
        className="text-primary hover:underline"
      >
        {t("termsOfService")}
      </a>{" "}
      &{" "}
      <a
        href="https://www.optogrid.com/privacy-policy/"
        target="_blank"
        className="text-primary hover:underline"
      >
        {t("privacyPolicy")}
      </a>
      .
    </div>
  );
}
